import React from 'react';
import PropTypes from 'prop-types';
import {Collapse} from 'antd';
import {withRouter} from 'react-router';
import TranslatedText from '../TranslatedText';
import {ReactComponent as ArrowDown} from '../../assets/img/arrowDown.svg';
import {ReactComponent as ArrowLeft} from '../../assets/img/arrowLeft.svg';
import _ from 'lodash';

const FaqPage = ({location}) => (
  <div id="faq-page" className="container">
    <h1><TranslatedText transKey="footer.faq.faq"/></h1>
    <Collapse defaultActiveKey={[_.get(location, 'state.active')]} expandIcon={({isActive}) => isActive ? <ArrowDown/> : <ArrowLeft/>}>
      <Collapse.Panel header={<TranslatedText transKey="faq.item1.question"/>} key="item1" id="item1">
        <p><TranslatedText transKey="faq.item1.answer"/></p>
      </Collapse.Panel>
      <Collapse.Panel header={<TranslatedText transKey="faq.item2.question"/>} key="item2" id="item2">
        <p><TranslatedText transKey="faq.item2.answer"/></p>
      </Collapse.Panel>
      <Collapse.Panel header={<TranslatedText transKey="faq.item3.question"/>} key="item3" id="item3" >
        <p>
          <TranslatedText transKey="faq.item3.answer"/>
        </p>
      </Collapse.Panel>
    </Collapse>
  </div>
);

FaqPage.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object.isRequired,
  }).isRequired,
};

export default withRouter(FaqPage);



// WEBPACK FOOTER //
// /src/components/pages/FaqPage.jsx